import moment from 'moment'
import { translation } from './helpers'

/**
 * @module utils/time
 */

export function padNumber (n, width, z) {
  z = z || '0'
  n = n + ''
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
}

export function formatDate (date, isNullable = false) {
  if ((date === null || date === '') && isNullable) return null
  if (date === null || date === '') return '1990-01-01T00:00:00'
  if (typeof date.format === 'function') {
    return date.format('YYYY-MM-DDTHH:mm:ss')
  }
  return date
}

/**
 * Renders descriptive date and time.
 * Ex. Monday, 10 Jan · 13.37
 */
export function renderDateTimeDesc (dateTime) {
  let locale = 'en'
  let languageName = window.localStorage.getItem('user_language')
  switch (languageName) {
    case 'Danish':
      locale = 'da'
      break
    case 'English':
      locale = 'en'
      break
    case 'Swedish':
      locale = 'se'
      break
    case 'Norwegian':
      locale = 'nb_NO'
      break
  }

  let mom = moment(dateTime).locale(locale)
  let dayOfWeek = mom.format('dddd')
  let day = mom.format('D')
  let month = mom.format('MMM')
  let hour = mom.format('k')   // "k" of all things...!
  let min = mom.format('mm')
  dayOfWeek = dayOfWeek.slice(0, 1).toUpperCase() + dayOfWeek.slice(1)
  month = month.slice(0, 1).toUpperCase() + month.slice(1)
  return `${dayOfWeek}, ${day} ${month} · ${hour}:${min}`
}

export function renderDate (dateTime) {
  if (!dateTime) return null
  return moment(dateTime).format('DD-MM-YYYY')
}

/**
 * @description Renders time as HH:MM DIFF
 * @example
 * let time = renderTime('2015-12-23T08:00:00')
 * @param  {string|date} time String or date object
 * @return {string} Returns formatted string
 */
export function renderTime (time) {
  if (time === '' || time == null) return ''

  // Create window.CustomDate object
  let d = window.CustomDate(time)

  // Check if date object is valid
  if (isNaN(d.getTime())) {
    return ''
  }

  // Hours + pad zero
  let hours = '' + d.getHours()
  hours = '00'.substring(0, 2 - hours.length) + hours

  // Minutes + pad zero
  let minutes = '' + d.getMinutes()
  minutes = '00'.substring(0, 2 - minutes.length) + minutes

  let cdate = window.CustomDate()
  // Month + pad zero
  let month = '' + (cdate.getMonth() + 1)
  month = '00'.substring(0, 2 - month.length) + month

  // Day + pad zero
  let day = '' + cdate.getDate()
  day = '00'.substring(0, 2 - day.length) + day
  let dd = cdate.getFullYear() + '-' + month + '-' + day + ' ' + '00' + ':' + '00' + ':00' // +  '00:00:00'
  let customDate = window.CustomDate(dd)

  let ddate = window.CustomDate(d)
  // Month + pad zero
  let dmonth = '' + (ddate.getMonth() + 1)
  dmonth = '00'.substring(0, 2 - dmonth.length) + dmonth

  // Day + pad zero
  let dday = '' + ddate.getDate()
  dday = '00'.substring(0, 2 - dday.length) + dday
  let ddd = ddate.getFullYear() + '-' + dmonth + '-' + dday + ' ' + '00' + ':' + '00' + ':00' // +  '00:00:00'
  let dcustomDate = window.CustomDate(ddd)

  // Diff today and time
  let diff = Math.floor((dcustomDate - customDate) / (1000 * 60 * 60 * 24))

  // Sign
  let sign = (diff > 0) ? '+' : ''
  if (diff === 0) {
    sign = ''
    diff = ''
  }

  // Return string with HOURS:MINUTES DIFF
  return hours + ':' + minutes + ' ' + sign + '' + diff
}

/**
 * @description Renders time as HH:MM
 * @example
 * let time = renderTime('2015-12-23T08:00:00')
 * @param  {string|date} time String or date object
 * @return {string} Returns formatted string
 */
export function renderTimeOnly (time) {
  if (time === '' || time == null) return ''

  // Create window.CustomDate object
  let d = window.CustomDate(time)

  // Check if date object is valid
  if (isNaN(d.getTime())) {
    return ''
  }

  // Hours + pad zero
  let hours = '' + d.getHours()
  hours = '00'.substring(0, 2 - hours.length) + hours

  // Minutes + pad zero
  let minutes = '' + d.getMinutes()
  minutes = '00'.substring(0, 2 - minutes.length) + minutes

  // Return string with HOURS:MINUTES DIFF
  return hours + ':' + minutes
}

export function getDateDiff (time) {
  if (time === '' || time == null) return ''

  // Create window.CustomDate object
  let d = window.CustomDate(time)

  // Check if date object is valid
  if (isNaN(d.getTime())) {
    return ''
  }

  let cdate = window.CustomDate()
  // Month + pad zero
  let month = '' + (cdate.getMonth() + 1)
  month = '00'.substring(0, 2 - month.length) + month

    // Day + pad zero
  let day = '' + cdate.getDate()
  day = '00'.substring(0, 2 - day.length) + day
  let dd = cdate.getFullYear() + '-' + month + '-' + day + ' ' + '00' + ':' + '00' + ':00' // +  '00:00:00'
  let customDate = window.CustomDate(dd)

  let ddate = window.CustomDate(d)
  // Month + pad zero
  let dmonth = '' + (ddate.getMonth() + 1)
  dmonth = '00'.substring(0, 2 - dmonth.length) + dmonth

  // Day + pad zero
  let dday = '' + ddate.getDate()
  dday = '00'.substring(0, 2 - dday.length) + dday
  let ddd = ddate.getFullYear() + '-' + dmonth + '-' + dday + ' ' + '00' + ':' + '00' + ':00' // +  '00:00:00'
  let dcustomDate = window.CustomDate(ddd)

  // Diff today and time
  let diff = Math.floor((dcustomDate - customDate) / (1000 * 60 * 60 * 24))

  return diff
}

/**
 * @description Renders time for API
 * @example
 * let time = renderDateTime('15-11-2016', '00:00:59')
 * @param  {String} time String with time
 * @param  {String} hourminutes String with fixed hh:mm:ss
 * @return {String} Returns formatted string
 */
export function renderDateTime (time, hourminutes) {
  if (time === '' || time == null) return ''

  if (typeof time.format === 'function') {
    return time.format('YYYY-MM-DD') + ' ' + hourminutes
  }

  let nTime = time.split('-')
  nTime = nTime[1] + '-' + nTime[0] + '-' + nTime[2]

  // Create window.CustomDate object
  let d = window.CustomDate(nTime)

  // Check if date object is valid
  if (isNaN(d.getTime())) {
    return ''
  }

  // Month + pad zero
  let month = '' + (d.getMonth() + 1)
  month = '00'.substring(0, 2 - month.length) + month

  // Day + pad zero
  let day = '' + d.getDate()
  day = '00'.substring(0, 2 - day.length) + day

  return d.getFullYear() + '-' + month + '-' + day + ' ' + hourminutes
}
/**
 * @param {Datetime} datetime
 * @param {boolean} weekday
 * @param {boolean} parentheses
 * @param {string} seperator
 * @returns
 */
export function renderShortDate (datetime, weekday = false, parentheses = false, seperator = ' • ') {
  const date = moment(datetime)

  if (!date.isValid()) {
    return false
  }

  let shortdate = date.format('DD-MM [' + seperator + '] HH:mm')

  // With weekday?
  shortdate = weekday ? getWeekDay(datetime, true) + ' ' + shortdate : shortdate

  // Enclose in parentheses?
  shortdate = parentheses ? '(' + shortdate + ')' : shortdate

  return shortdate
}

export function renderDateDiff (datetime, relativeToDatetime) {
  const date = moment(datetime)
  const relativeTodate = moment(relativeToDatetime)

  if (!date.isValid() || !relativeTodate.isValid()) {
    return false
  }

  // How many days ahead/behind
  return date.diff(relativeTodate, 'days')
}

/**
 * @description Renders time as dd-mm-YYYY H:i
 * @example
 * let time = renderFullDate('2015-12-23T08:00:00')
 * @param  {string|date} time String or date object
 * @return {string} Returns formatted string
 */
export function renderFullDate (time, includeTime, onlyTime) {
  if (time === '' || time == null) return ''

  // Create window.CustomDate object
  let d = window.CustomDate(time)

  // Check if date object is valid
  if (isNaN(d.getTime())) {
    return ''
  }

  // Day + pad zero
  let day = '' + d.getDate()
  day = '00'.substring(0, 2 - day.length) + day

  // Month + pad zero
  let month = '' + (d.getMonth() + 1)
  month = '00'.substring(0, 2 - month.length) + month

  // Hours + pad zero
  let hours = '' + d.getHours()
  hours = '00'.substring(0, 2 - hours.length) + hours

  // Minutes + pad zero
  let minutes = '' + d.getMinutes()
  minutes = '00'.substring(0, 2 - minutes.length) + minutes

  let hoursAndMinutes = ' - ' + hours + ':' + minutes
  if (typeof includeTime !== 'undefined') {
    if (!includeTime) {
      hoursAndMinutes = ''
    }
  }
  if (typeof onlyTime !== 'undefined') {
    return hoursAndMinutes.replace(' - ', '')
  }

  // Return string
  // console.log('Render date: ', d, ' as ', d.getUTCFullYear(), d.getFullYear())
  // seems utcfullyear returns wrong year if date is ex. 01-01-2018 (gives 01-01-2017) Switched to getFullYear
  return day + '-' + month + '-' + d.getFullYear() + hoursAndMinutes
}

 /**
  * @description Inserts hours & minutes in datetime string
  * @example
  * let newTime = setHourMin('2017-05-01T08:00:00', '12:55')
  * @param {string} dateTime Datetime string
  * @param {string} hhmm Hours and minutes to insert into datetime string
  * @return {string} Returns formatted string
  */
export function setHourMin (dateTime, hhmm) {
    // Format is 2017-04-02T10:41:16
  if (hhmm !== null && hhmm.length === 4) {
    if (hhmm.indexOf(':') === -1) {
      hhmm = hhmm.substring(0, 2) + ':' + hhmm.substring(2, 4)
    } else if (hhmm.indexOf(':') === 1) {
      hhmm = '0' + hhmm
    }
  }
  if (dateTime === null) return hhmm
  return dateTime.substring(0, 11) + hhmm
}

/**
 * @param {datetime} datetime Datetime
 */
export function getWeekDay (datetime, short = false) {
  const date = new Date(datetime)
  let weekday = date.getDay()
  let day

  switch (weekday) {
    case 0: // sunday
      day = translation('175')
      break
    case 1: // monday
      day = translation('169')
      break
    case 2: // ..
      day = translation('170')
      break
    case 3: // ..
      day = translation('171')
      break
    case 4: // ..
      day = translation('172')
      break
    case 5: // friday
      day = translation('173')
      break
    case 6: // saturday
      day = translation('174')
      break
  }

  return short ? day.substring(0, 3) : day
}

/**
 * @description Formats a date relative to now
 * @example const relativeDate = getRelativeDateTime('2020-01-21T08:00:00')
 * @param {datetime} datetime Datetime
 * @return {string} Date string relative to now
 */
export function getRelativeDateTime (datetime) {
  if (!datetime) return ''

  const date = moment(datetime)
  const today = moment()
  let pre = ''
  let relativeToday = ''

  const diff = today.dayOfYear() - date.dayOfYear()
  if (!diff) {
    relativeToday = '238'
  } else if (diff === -1) {
    relativeToday = '16532'
  } else if (diff === 1) {
    relativeToday = '16533'
  } else {
    switch (date.day()) {
      case 0:
        relativeToday = '175'
        break
      case 1:
        relativeToday = '169'
        break
      case 2:
        relativeToday = '170'
        break
      case 3:
        relativeToday = '171'
        break
      case 4:
        relativeToday = '172'
        break
      case 5:
        relativeToday = '173'
        break
      case 6:
        relativeToday = '174'
        break
    }

    if (diff > 0 && diff <= 6) {
      pre = '15062' // "Last"
    }
  }

  const preValue = pre ? `${translation(pre)} ` : ''
  const relative = `${preValue}${translation(relativeToday)}, ${date.format(translation('16534'))}`

  return relative
}



// WEBPACK FOOTER //
// ./src/app/utils/time.js